// PUT の body は Swagger 準拠（reportId は path パラメータなので含めない）
export interface BusinessReportPutRequest {
  id: number;
  date: string; // "YYYY-MM-DD"
  projectId: number;
  projectNo: string;
  projectName: string;
  manHoursCategory: 'A' | 'B' | 'C' | 'D' | 'E' | '';
  startTime: string; // "HH:mm"
  endTime: string; // "HH:mm"
  manHoursTotal: number;
}

export interface FormattedBusinessReportPutRequest {
  id: number;
  date: string; // "YYYY-MM-DD"
  projectId: number;
  manHoursA: boolean;
  manHoursB: boolean;
  manHoursC: boolean;
  manHoursD: boolean;
  manHoursE: boolean;
  startTime: string; // "HH:mm"
  endTime: string; // "HH:mm"
  manHoursTotal: number;
}

export const formatBusinessReportPutRequest = (
  item: BusinessReportPutRequest
): FormattedBusinessReportPutRequest => {
  return {
    id: item.id,
    date: item.date,
    projectId: item.projectId,
    manHoursA: item.manHoursCategory === 'A',
    manHoursB: item.manHoursCategory === 'B',
    manHoursC: item.manHoursCategory === 'C',
    manHoursD: item.manHoursCategory === 'D',
    manHoursE: item.manHoursCategory === 'E',
    startTime: item.startTime,
    endTime: item.endTime,
    manHoursTotal: item.manHoursTotal,
  };
};

export const EmptyBusinessReportPutRequest: BusinessReportPutRequest = {
  id: 0,
  date: '',
  projectId: 0,
  projectNo: '',
  projectName: '',
  manHoursCategory: '',
  startTime: '',
  endTime: '',
  manHoursTotal: 0,
};

// カテゴリキー（A〜E）とその型
export const MAN_HOURS_CATEGORY_KEYS = ['A', 'B', 'C', 'D', 'E'];
